// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-layout {
  display: flex;
}
.account-layout .background-account {
  position: absolute;
  top: 260px;
  left: 125px;
}
.account-layout .logo {
  position: absolute;
  left: 41px;
  top: 42px;
}
.account-layout .logo > img {
  width: 250px;
  margin-right: 18px;
}
.account-layout .account-layout-body {
  margin-top: 150px;
  padding: 50px 100px;
}
.account-layout .account-layout-body > h3 {
  text-transform: uppercase;
  color: var(--flexi-primary-color);
  font-size: 23px;
  font-weight: bold;
  margin-bottom: 35px;
}
.account-layout .account-layout-body .ant-input-affix-wrapper {
  width: 300px;
}
[class^="ant-"],
[class*=" ant-"] {
  font-family: Mulish, sans-serif !important;
}
.versions_tree .ant-collapse-content {
  background-color: var(--flexi-col-table) !important;
  border-top: 1px solid var(--flexi-border) !important;
}
.offers-archives-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 0 !important;
}
.offers-archives-collapse .ant-collapse-content-box {
  padding: 0 !important;
}
.versions_tree .ant-collapse-header {
  align-items: baseline !important;
}
.versions_tree .ant-timeline-item {
  padding: 0 !important;
}
.versions_tree .ant-timeline-item-content {
  margin: 0 0 0 20px !important;
}
.versions_tree .ant-collapse-content-box {
  padding: 30px !important;
}
.ant-switch {
  border: none !important;
}
.ant-switch-handle {
  width: 16px !important;
  height: 16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}
.ant-switch-handle::before {
  box-shadow: none !important;
  background-color: #fff !important;
}
.ant-switch-small .ant-switch-handle {
  width: 10px !important;
  height: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}
.ant-timeline-item-head {
  padding: 0 !important;
}
.ant-timeline-item-tail {
  border-left: 2px dotted var(--flexi-grey) !important;
}
.timeline_container {
  padding-top: 20px;
}
.timeline_container .ant-timeline-item-label {
  width: 180px !important;
  color: var(--flexi-grey) !important;
  font-size: 14px;
  top: -6.5px !important;
  text-align: left !important;
}
.timeline_container .ant-timeline-item-content {
  left: 180px !important;
  width: calc(80% - 4px) !important;
}
.timeline_container .ant-timeline-item-tail,
.timeline_container .ant-timeline-item-head {
  left: 180px !important;
}
.ant-timeline-item-last > .ant-timeline-item-content {
  min-height: 0 !important;
}
.ant-btn {
  font-weight: 700 !important;
}
.ant-btn-default {
  color: var(--flexi-primary-color);
  border-color: var(--flexi-primary-color);
}
.ant-btn-primary .ant-btn[disabled],
.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary[disabled]:active.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:active {
  opacity: 0.3 !important;
  color: #fff !important;
  background-color: var(--flexi-primary-color) !important;
  border-color: var(--flexi-primary-color) !important;
}
.ant-btn-default[disabled],
.ant-btn-default[disabled]:hover,
.ant-btn-default[disabled]:focus,
.ant-btn-default[disabled]:active {
  opacity: 0.3 !important;
  color: var(--flexi-primary-color) !important;
  background-color: #fff !important;
  border-color: var(--flexi-primary-color) !important;
}
.btn-undo-redo:hover {
  border-color: var(--flexi-primary-color) !important;
}
.btn-undo-redo,
.btn-undo-redo[disabled],
.btn-undo-redo[disabled]:hover,
.btn-undo-redo[disabled]:focus,
.btn-undo-redo[disabled]:active {
  color: var(--flexi-text) !important;
  border-color: var(--flexi-border) !important;
}
.ant-btn-danger[disabled],
.ant-btn-danger[disabled]:hover,
.ant-btn-danger[disabled]:focus,
.ant-btn-danger[disabled]:active {
  opacity: 0.3 !important;
  color: #fff !important;
  background-color: var(--flexi-red) !important;
  border-color: var(--flexi-red) !important;
}
.ant-btn-loading-icon {
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
}
.ant-btn-text:hover,
.ant-btn-text:focus {
  background-color: transparent !important;
}
.ant-btn-icon-only {
  justify-content: center !important;
  align-items: center !important;
  display: flex !important;
}
.ant-btn-primary[variant="outlined"] {
  color: var(--flexi-primary-color) !important;
  background-color: white !important;
  border-color: var(--flexi-primary-color) !important;
}
.confirm-filter-btn {
  border-radius: 50px !important;
  padding: 0 10px !important;
}
.ant-table-thead > tr > th {
  font-weight: 700 !important;
  font-size: 13px !important;
  padding: 0 8px !important;
  height: 36px !important;
  background-color: var(--flexi-col-table) !important;
}
.ant-table-measure-row {
  height: 0 !important;
  min-height: 0 !important;
}
.ant-table-measure-row td {
  padding: 0 !important;
  border: none !important;
  height: 0 !important;
}
td.ant-table-column-sort,
.ant-table-tbody > tr.ant-table-row > td {
  background-color: #fff !important;
}
.ant-table-tbody > tr.ant-table-row {
  position: relative;
  transition: box-shadow 0.3s linear;
}
.ant-table-tbody > tr.ant-table-row:hover {
  box-shadow: 0 6px 15px 0 var(--flexi-placeholder);
}
.ant-table-column-sorter-inner .active {
  color: var(--flexi-primary-color) !important;
}
.ant-table-filter-trigger,
.ant-table-column-sorter {
  color: var(--flexi-grey) !important;
}
.ant-table-filter-trigger .active,
.ant-table-column-sorter .active {
  color: var(--flexi-primary-color) !important;
}
.ant-table-filter-dropdown .ant-checkbox-checked::after {
  border: 1px solid var(--flexi-primary-color);
}
.ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--flexi-primary-color);
  border-color: var(--flexi-primary-color);
}
.ant-table-filter-dropdown .ant-dropdown-menu-item-selected,
.ant-table-filter-dropdown .ant-dropdown-menu-submenu-title-selected {
  color: var(--flexi-primary-color);
}
.ant-table-filter-dropdown .ant-btn-link {
  color: var(--flexi-primary-color);
}
.ant-table-filter-dropdown .ant-btn-primary {
  border-color: var(--flexi-primary-color);
  background-color: var(--flexi-primary-color);
}
.ant-pagination-item-active {
  background-color: var(--flexi-primary-color) !important;
  border: none !important;
}
.ant-pagination-item-active a {
  color: #fff !important;
}
.ant-pagination-item {
  border: none !important;
}
.ant-pagination-item:hover {
  color: var(--flexi-primary-color) !important;
}
.ant-pagination-item-link {
  border: none !important;
}
.info-pdf .ant-table-cell a {
  color: var(--flexi-primary-color) !important;
}
.ant-select-dropdown {
  width: 30%;
}
.ant-select-dropdown ul:nth-child(3) {
  flex-grow: 1;
}
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: var(--flexi-select-active) !important;
}
.ant-select-selector {
  border-radius: 2px !important;
}
.ant-select-arrow svg {
  fill: currentcolor;
  color: #000;
}
.ant-select-open .ant-select-selection-item {
  color: #000 !important;
}
.ant-select-item-option-state {
  font-size: 10px !important;
}
.ant-select-item {
  padding: 0 12px !important;
  margin: 0 !important;
  line-height: normal;
  display: flex;
  align-items: center;
}
.ant-alert {
  margin-top: 8px;
  border: none !important;
}
.ant-message-notice-content {
  border-radius: 10px;
  min-width: 240px;
  max-width: 80vw;
  font-size: 14px;
  line-height: 16px;
  padding: 12px 24px;
}
.ant-alert-success,
.ant-notification-notice-success,
.ant-message-notice-success .ant-message-notice-content {
  background-color: var(--flexi-valid-toaster) !important;
  border-radius: 10px !important;
}
.ant-message-notice-info .ant-message-notice-content {
  background-color: var(--flexi-info-toaster) !important;
  border-radius: 10px !important;
}
.ant-message-info .anticon,
.ant-message-loading .anticon {
  color: var(--flexi-primary-color) !important;
}
.ant-alert-error,
.ant-notification-notice-error,
.ant-message-notice-error .ant-message-notice-content {
  background-color: var(--flexi-error-toaster) !important;
  border-radius: 10px !important;
}
.ant-notification-notice-message,
.ant-notification-notice-description,
.ant-message-success .anticon,
.ant-message-error .anticon {
  font-size: 14px !important;
  line-height: 16px !important;
}
.ant-notification-notice-error .ant-notification-notice-message,
.ant-notification-notice-error .ant-notification-notice-description {
  color: var(--flexi-error) !important;
}
.ant-notification-notice .ant-notification-notice-close {
  color: var(--flexi-grey) !important;
  top: 5px !important;
  right: 12px !important;
}
.ant-notification-notice-icon {
  font-size: 18px !important;
  min-width: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}
.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 35px !important;
}
.ant-notification-notice-success .ant-notification-notice-message,
.ant-notification-notice-success .ant-notification-notice-description,
.ant-message-success {
  color: var(--flexi-valid) !important;
}
.ant-notification-notice {
  display: inline-block !important;
  width: auto !important;
  max-width: 80vw !important;
  white-space: nowrap !important;
  min-width: 240px !important;
}
.ant-notification-notice-with-icon .ant-notification-notice-message,
.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 35px !important;
}
.ant-notification-top {
  left: 50% !important;
  transform: translateX(-50%) !important;
  right: auto !important;
  top: 24px !important;
}
.ant-notification-fade-enter,
.ant-notification-fade-appear {
  animation-name: NotificationFadeInDown !important;
}
@keyframes NotificationFadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.ant-cascader {
  width: 80%;
}
.ant-input-number .ant-input-number-handler-wrap,
.ant-input-number-focused .ant-input-number-handler-wrap {
  opacity: 1;
}
.ant-input-number-affix-wrapper .ant-input-number-handler-wrap {
  z-index: 0;
}
.ant-input-number-sm {
  width: 75px;
}
.ant-input-number {
  width: 70px;
  border-radius: 2px !important;
}
.ant-input-prefix {
  color: var(--flexi-placeholder) !important;
}
.ant-input {
  border-radius: 2px !important;
}
.ant-table-filter-dropdown .ant-checkbox-checked,
.ant-collapse .ant-checkbox-checked {
  top: 0;
}
.ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-inner,
.ant-collapse .ant-checkbox-checked .ant-checkbox-inner {
  position: absolute !important;
  top: -2px;
}
.ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-input,
.ant-collapse .ant-checkbox-checked .ant-checkbox-input {
  margin-right: 14px;
}
.ant-collapse .checkbox-all-outside .ant-checkbox {
  margin-left: 27px;
}
.ant-tree-draggable-icon {
  cursor: grab;
}
.ant-tree-draggable-icon:active {
  cursor: grabbing;
}
.ant-modal-content {
  border-radius: 20px !important;
  padding: 30px 10px !important;
}
.modal-preview-document .ant-modal-content {
  padding: 0 !important;
}
.ant-btn-text span,
.ant-modal-footer .ant-btn-default span,
.ant-popover-buttons .ant-btn-default span {
  text-decoration: underline !important;
}
.ant-modal-header {
  border-bottom: none !important;
  border-radius: 20px 20px 0 0 !important;
}
.ant-modal-footer {
  padding: 0px 24px !important;
  border-top: none !important;
}
.ant-modal-title {
  font-size: 24px !important;
  font-weight: 700 !important;
  line-height: 30px !important;
}
.ant-modal-footer .ant-btn-default,
.ant-popover .ant-btn-cancel {
  background: none !important;
  border: none !important;
  color: var(--flexi-primary-color, #2CB4AD) !important;
  font-weight: 400 !important;
  box-shadow: none !important;
  cursor: pointer;
}
.ant-popover .ant-btn {
  border: none !important;
  box-shadow: none !important;
}
.ant-modal-body {
  padding-top: 0;
}
.ant-modal-body > p {
  font-size: 14px;
  margin-bottom: 30px;
}
.ant-modal-body > b {
  font-size: 13px;
}
.ant-modal-body > .ant-input-affix-wrapper {
  border-radius: 25px !important;
  font-weight: bold;
  font-size: 13px;
  margin: 7px 0;
}
.ant-modal-body > .ant-input-affix-wrapper svg {
  color: var(--flexi-placeholder);
}
.modal-buttons {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}
.modal-buttons .ant-btn-text {
  color: var(--flexi-primary-color);
}
.ant-popover-message > .anticon {
  color: var(--flexi-warning) !important;
}
.ant-table-tbody .ant-table-cell .anticon {
  transition: all 0.3s linear;
  border-radius: 4px;
}
.ant-table-tbody .ant-table-cell .anticon:hover {
  background-color: var(--flexi-col-table) !important;
}
.ant-tag-custom .ant-tag {
  margin: 0 !important;
  padding: 0 !important;
}
.flexi-rich-tooltip .ant-tooltip-inner {
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-family: Roboto, sans-serif;
  white-space: normal;
  max-width: 450px;
  min-width: 0;
}
.flexi-rich-tooltip .ant-tooltip-arrow {
  display: none;
}
.flexi-rich-tooltip ul {
  margin: 4px 0 0;
  padding-left: 16px;
  list-style: disc;
}
.flexi-rich-tooltip ul li {
  margin: 0;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./app/less/account.less","webpack://./app/less/antd-custom.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAFA;EAII,kBAAA;EACA,UAAA;EACA,WAAA;AACJ;AAPA;EAUI,kBAAA;EACA,UAAA;EACA,SAAA;AAAJ;AAZA;EAeM,YAAA;EACA,kBAAA;AAAN;AAhBA;EAqBI,iBAAA;EACA,mBAAA;AAFJ;AApBA;EAyBM,yBAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAFN;AA3BA;EAiCM,YAAA;AAHN;AC9BA;;EACE,0CAAA;ADiCF;ACZA;EACE,mDAAA;EACA,oDAAA;ADcF;ACXA;EAEI,qBAAA;ADYJ;ACdA;EAKI,qBAAA;ADYJ;ACRA;EAEI,gCAAA;ADSJ;ACXA;EAMI,qBAAA;ADQJ;ACdA;EAUI,6BAAA;ADOJ;ACjBA;EAcI,wBAAA;ADMJ;ACDA;EACE,uBAAA;ADGF;ACAA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;ADEF;ACAE;EACE,2BAAA;EACA,iCAAA;ADEJ;ACEA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;ADAF;ACIA;EACE,qBAAA;ADFF;ACKA;EACE,oDAAA;ADHF;ACMA;EACE,iBAAA;ADJF;ACGA;EAII,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,sBAAA;EACA,2BAAA;ADJJ;ACJA;EAYI,sBAAA;EACA,iCAAA;ADLJ;ACRA;;EAkBI,sBAAA;ADNJ;ACUA;EACE,wBAAA;ADRF;ACYA;EACE,2BAAA;ADVF;ACaA;EACE,iCAAA;EACA,wCAAA;ADXF;ACcA;;;;;;EACE,uBAAA;EACA,sBAAA;EACA,uDAAA;EACA,mDAAA;ADPF;ACUA;;;;EACE,uBAAA;EACA,4CAAA;EACA,iCAAA;EACA,mDAAA;ADLF;ACQA;EACE,mDAAA;ADNF;ACSA;;;;;EACE,mCAAA;EACA,4CAAA;ADHF;ACMA;;;;EACE,uBAAA;EACA,sBAAA;EACA,6CAAA;EACA,yCAAA;ADDF;ACIA;EACE,uEAAA;ADFF;ACKA;;EACE,wCAAA;ADFF;ACKA;EACE,kCAAA;EACA,8BAAA;EACA,wBAAA;ADHF;ACMA;EACE,4CAAA;EACA,kCAAA;EACA,mDAAA;ADJF;ACOA;EACE,8BAAA;EACA,0BAAA;ADLF;ACQA;EACE,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,uBAAA;EACA,mDAAA;ADNF;ACSA;EACE,oBAAA;EACA,wBAAA;ADPF;ACKA;EAKI,qBAAA;EACA,uBAAA;EACA,oBAAA;ADPJ;ACWA;;EACE,iCAAA;ADRF;ACWA;EACE,kBAAA;EACA,kCAAA;ADTF;ACWE;EACE,iDAAA;ADTJ;ACaA;EACE,4CAAA;ADXF;ACcA;;EACE,mCAAA;ADXF;ACUA;;EAII,4CAAA;ADVJ;ACgBI;EACE,4CAAA;ADdN;ACWA;EAOM,4CAAA;EACA,wCAAA;ADfN;ACOA;;EAaI,iCAAA;ADhBJ;ACGA;EAiBI,iCAAA;ADjBJ;ACAA;EAqBI,wCAAA;EACA,4CAAA;ADlBJ;ACsBA;EACE,uDAAA;EACA,uBAAA;ADpBF;ACkBA;EAKI,sBAAA;ADpBJ;ACwBA;EACE,uBAAA;ADtBF;ACwBE;EACE,4CAAA;ADtBJ;AC0BA;EACE,uBAAA;ADxBF;AC2BA;EACE,4CAAA;ADzBF;ACgCA;EACE,UAAA;AD9BF;AC6BA;EAII,YAAA;AD9BJ;ACkCA;EACE,uDAAA;ADhCF;ACmCA;EACE,6BAAA;ADjCF;ACoCA;EACC,kBAAA;EACA,WAAA;ADlCD;ACqCA;EACE,sBAAA;ADnCF;ACsCA;EACE,0BAAA;ADpCF;ACuCA;EACE,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;ADrCF;ACyCA;EACE,eAAA;EACA,uBAAA;ADvCF;AC0CA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ADxCF;AC2CA;;;EACE,uDAAA;EACA,8BAAA;ADvCF;AC0CA;EACE,sDAAA;EACA,8BAAA;ADxCF;AC2CA;;EACE,4CAAA;ADxCF;AC2CA;;;EACE,uDAAA;EACA,8BAAA;ADvCF;AC0CA;;;;EAGE,0BAAA;EACA,4BAAA;ADvCF;AC0CA;;EAEE,oCAAA;ADxCF;AC2CA;EACE,mCAAA;EACA,mBAAA;EACA,sBAAA;ADzCF;AC4CA;EACE,0BAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AD1CF;AC6CA;EACE,8BAAA;AD3CF;AC8CA;;;EAEE,oCAAA;AD3CF;AC8CA;EACE,gCAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;AD5CF;AC+CA;;EACE,4BAAA;AD5CF;AC+CA;EACE,oBAAA;EACA,sCAAA;EACA,sBAAA;EACA,oBAAA;AD7CF;ACgDA;;EACE,iDAAA;AD7CF;ACgDA;EACE;IACE,UAAA;IACA,4BAAA;ED9CF;ECiDA;IACE,UAAA;IACA,wBAAA;ED/CF;AACF;ACkDA;EACE,UAAA;ADhDF;ACqDA;;EACE,UAAA;ADlDF;ACqDA;EACE,UAAA;ADnDF;ACsDA;EACE,WAAA;ADpDF;ACuDA;EACE,WAAA;EACA,6BAAA;ADrDF;ACwDA;EACE,0CAAA;ADtDF;ACyDA;EACE,6BAAA;ADvDF;AC0DA;;EACE,MAAA;ADvDF;ACsDA;;EAII,6BAAA;EACA,SAAA;ADtDJ;ACiDA;;EASI,kBAAA;ADtDJ;AC0DA;EACC,iBAAA;ADxDD;AC2DA;EACE,YAAA;ADzDF;AC2DI;EACA,gBAAA;ADzDJ;AC8DA;EACE,8BAAA;EACA,6BAAA;AD5DF;AC+DA;EACE,qBAAA;AD7DF;ACgEA;;;EACE,qCAAA;AD5DF;AC+DA;EACE,8BAAA;EACA,uCAAA;AD7DF;ACgEA;EACE,4BAAA;EACA,2BAAA;AD9DF;ACiEA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;AD/DF;ACkEA;;EACE,2BAAA;EACA,uBAAA;EACA,qDAAA;EACA,2BAAA;EACA,2BAAA;EACA,eAAA;AD/DF;ACkEA;EACE,uBAAA;EACA,2BAAA;ADhEF;ACmEA;EACI,cAAA;ADjEJ;ACgEA;EAIM,eAAA;EACA,mBAAA;ADjEN;AC4DA;EASM,eAAA;ADlEN;ACyDA;EAaM,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;ADnEN;ACmDA;EAmBQ,+BAAA;ADnER;ACyEA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;ADvEF;ACoEA;EAMI,iCAAA;ADvEJ;AC2EA;EACE,sCAAA;ADzEF;AC4EA;EACE,2BAAA;EACA,kBAAA;AD1EF;AC4EE;EACE,mDAAA;AD1EJ;AC8EA;EACE,oBAAA;EACA,qBAAA;AD5EF;ACgFA;EAEI,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,yCAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AD/EJ;ACoEA;EAeI,aAAA;ADhFJ;ACiEA;EAmBI,eAAA;EACA,kBAAA;EACA,gBAAA;ADjFJ;AC4DA;EAwBM,SAAA;EACA,UAAA;ADjFN","sourcesContent":[".account-layout {\n  display: flex;\n\n  .background-account {\n    position: absolute;\n    top: 260px;\n    left: 125px;\n  }\n\n  .logo {\n    position: absolute;\n    left: 41px;\n    top: 42px;\n\n    > img {\n      width: 250px;\n      margin-right: 18px;\n    }\n  }\n\n  .account-layout-body {\n    margin-top: 150px;\n    padding: 50px 100px;\n\n    > h3 {\n      text-transform: uppercase;\n      color: var(--flexi-primary-color);\n      font-size: 23px;\n      font-weight: bold;\n      margin-bottom: 35px;\n    }\n\n    .ant-input-affix-wrapper {\n      width: 300px;\n    }\n  }\n\n}\n\n@hack: true; @import \"/service/app/less/antd-custom.less\";","[class^=\"ant-\"], [class*=\" ant-\"] {\n  font-family: Mulish, sans-serif !important;\n}\n@input-font-size: 13px;\n@input-font-size-lg: 14px;\n@border-radius-base: 4px;\n\n@btn-padding-horizontal-lg: 30px;\n@btn-padding-horizontal-base: 20px;\n@btn-border-radius-base: 30px;\n\n@select-single-item-height-lg: 50px;\n\n@primary-color: #2CB4AD;\n\n@slider-handle-border-width: 8px;\n\n@btn-default-border: #E5E7EB;\n@btn-default-color: #2CB4AD;;\n@btn-font-size-lg: 14px;\n\n// ANT COLLAPSE\n.versions_tree .ant-collapse-content {\n  background-color: var(--flexi-col-table) !important;\n  border-top: 1px solid var(--flexi-border) !important;\n}\n\n.offers-archives-collapse {\n  > .ant-collapse-item > .ant-collapse-header {\n    padding: 0 !important;\n  }\n  .ant-collapse-content-box {\n    padding: 0 !important;\n  }\n}\n\n.versions_tree {\n  .ant-collapse-header {\n    align-items: baseline !important;\n  }\n\n  .ant-timeline-item {\n    padding: 0 !important;\n  }\n\n  .ant-timeline-item-content {\n    margin: 0 0 0 20px !important;\n  }\n  \n  .ant-collapse-content-box {\n    padding: 30px !important;\n  }\n}\n\n// ANT SWITCH\n.ant-switch {\n  border:none !important;\n}\n\n.ant-switch-handle {\n  width: 16px !important;\n  height: 16px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n\n  &::before {\n    box-shadow: none !important;\n    background-color: #fff !important;\n  }\n}\n\n.ant-switch-small .ant-switch-handle {\n  width: 10px !important;\n  height: 10px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n}\n\n// ANT TIMELINE\n.ant-timeline-item-head {\n  padding: 0 !important;\n}\n\n.ant-timeline-item-tail {\n  border-left: 2px dotted var(--flexi-grey) !important;\n}\n\n.timeline_container {\n  padding-top: 20px;\n\n  .ant-timeline-item-label {\n    width: 180px !important;\n    color: var(--flexi-grey) !important;\n    font-size: 14px;\n    top: -6.5px !important;\n    text-align: left !important;\n  }\n\n  .ant-timeline-item-content {\n    left: 180px !important;\n    width: calc(80% - 4px) !important;\n  }\n\n  .ant-timeline-item-tail,\n  .ant-timeline-item-head {\n    left: 180px !important;\n  }\n}\n\n.ant-timeline-item-last > .ant-timeline-item-content {\n  min-height: 0 !important;\n}\n\n// ANT BUTTON\n.ant-btn {\n  font-weight: 700 !important;\n}\n\n.ant-btn-default {\n  color: var(--flexi-primary-color);\n  border-color: var(--flexi-primary-color)\n}\n\n.ant-btn-primary .ant-btn[disabled], .ant-btn-primary[disabled], .ant-btn-primary[disabled]:hover, .ant-btn-primary[disabled]:focus, .ant-btn-primary[disabled]:active.ant-btn-primary[disabled], .ant-btn-primary[disabled]:active {\n  opacity: 0.3 !important;\n  color: #fff !important;\n  background-color: var(--flexi-primary-color) !important;\n  border-color: var(--flexi-primary-color) !important;\n}\n\n.ant-btn-default[disabled], .ant-btn-default[disabled]:hover, .ant-btn-default[disabled]:focus, .ant-btn-default[disabled]:active {\n  opacity: 0.3 !important;\n  color: var(--flexi-primary-color) !important;\n  background-color: #fff !important;\n  border-color: var(--flexi-primary-color) !important;\n}\n\n.btn-undo-redo:hover {\n  border-color: var(--flexi-primary-color) !important;\n}\n\n.btn-undo-redo, .btn-undo-redo[disabled], .btn-undo-redo[disabled]:hover, .btn-undo-redo[disabled]:focus, .btn-undo-redo[disabled]:active{\n  color: var(--flexi-text) !important;\n  border-color: var(--flexi-border) !important;\n}\n\n.ant-btn-danger[disabled], .ant-btn-danger[disabled]:hover, .ant-btn-danger[disabled]:focus, .ant-btn-danger[disabled]:active {\n  opacity: 0.3 !important;\n  color: #fff !important;\n  background-color: var(--flexi-red) !important;\n  border-color: var(--flexi-red) !important;\n}\n\n.ant-btn-loading-icon {\n  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out !important; // fix firefox displayed loading icon\n}\n\n.ant-btn-text:hover, .ant-btn-text:focus {\n  background-color: transparent !important;\n}\n\n.ant-btn-icon-only {\n  justify-content: center !important;\n  align-items: center !important;\n  display: flex !important;\n}\n\n.ant-btn-primary[variant=\"outlined\"] {\n  color: var(--flexi-primary-color) !important;\n  background-color: white !important;\n  border-color: var(--flexi-primary-color) !important;\n}\n\n.confirm-filter-btn {\n  border-radius: 50px !important;\n  padding: 0 10px !important;\n}\n// ANT TABLE\n.ant-table-thead > tr > th {\n  font-weight: 700 !important;\n  font-size: 13px !important;\n  padding: 0 8px !important;\n  height: 36px !important;\n  background-color: var(--flexi-col-table) !important;\n}\n\n.ant-table-measure-row {\n  height: 0 !important;\n  min-height: 0 !important;\n\n  td {\n    padding: 0 !important;\n    border: none !important;\n    height: 0 !important;\n  }\n}\n\ntd.ant-table-column-sort, .ant-table-tbody > tr.ant-table-row > td {\n  background-color: #fff !important;\n}\n\n.ant-table-tbody > tr.ant-table-row {\n  position: relative;\n  transition: box-shadow .3s linear;\n\n  &:hover {\n    box-shadow: 0 6px 15px 0 var(--flexi-placeholder);\n  }\n}\n\n.ant-table-column-sorter-inner .active {\n  color: var(--flexi-primary-color) !important;\n}\n\n.ant-table-filter-trigger, .ant-table-column-sorter {\n  color: var(--flexi-grey) !important;\n\n  .active {\n    color: var(--flexi-primary-color) !important;\n  }\n}\n\n.ant-table-filter-dropdown {\n  .ant-checkbox-checked {\n    &::after {\n      border: 1px solid var(--flexi-primary-color);\n    }\n\n    .ant-checkbox-inner {\n      background-color: var(--flexi-primary-color);\n      border-color: var(--flexi-primary-color);\n    }\n  }\n\n  .ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected {\n    color: var(--flexi-primary-color);\n  }\n\n  .ant-btn-link {\n    color: var(--flexi-primary-color);\n  }\n\n  .ant-btn-primary {\n    border-color: var(--flexi-primary-color);\n    background-color: var(--flexi-primary-color);\n  }\n}\n\n.ant-pagination-item-active {\n  background-color: var(--flexi-primary-color) !important;\n  border: none !important;\n\n  a {\n    color: #fff !important;\n  }\n}\n\n.ant-pagination-item {\n  border: none !important;\n\n  &:hover {\n    color: var(--flexi-primary-color) !important;\n  }\n}\n\n.ant-pagination-item-link {\n  border: none !important;\n}\n\n.info-pdf .ant-table-cell a {\n  color: var(--flexi-primary-color) !important;\n}\n\n// ANT SELECT\n@select-selection-item-bg: var(--flexi-select-active);\n@select-selection-item-border-color: var(--flexi-border);\n\n.ant-select-dropdown{\n  width: 30%;\n\n  ul:nth-child(3){\n    flex-grow: 1;\n  }\n}\n\n.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n  background-color: var(--flexi-select-active) !important;\n}\n\n.ant-select-selector{\n  border-radius: 2px !important;\n}\n\n.ant-select-arrow svg{\n fill: currentcolor;\n color: #000;\n}\n\n.ant-select-open .ant-select-selection-item{\n  color: #000 !important;\n}\n\n.ant-select-item-option-state {\n  font-size: 10px !important;\n}\n\n.ant-select-item {\n  padding: 0 12px !important;\n  margin: 0 !important;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n}\n\n// NOTIFICATION & ALERT\n.ant-alert {\n  margin-top: 8px;\n  border:none !important;\n}\n\n.ant-message-notice-content {\n  border-radius: 10px;\n  min-width: 240px;\n  max-width: 80vw;\n  font-size: 14px;\n  line-height: 16px;\n  padding: 12px 24px;\n}\n\n.ant-alert-success, .ant-notification-notice-success, .ant-message-notice-success .ant-message-notice-content  {\n  background-color: var(--flexi-valid-toaster) !important;\n  border-radius: 10px !important;\n}\n\n.ant-message-notice-info .ant-message-notice-content  {\n  background-color: var(--flexi-info-toaster) !important;\n  border-radius: 10px !important;\n}\n\n.ant-message-info .anticon, .ant-message-loading .anticon {\n  color: var(--flexi-primary-color) !important;\n}\n\n.ant-alert-error, .ant-notification-notice-error, .ant-message-notice-error .ant-message-notice-content {\n  background-color: var(--flexi-error-toaster) !important;\n  border-radius: 10px !important;\n}\n\n.ant-notification-notice-message,\n.ant-notification-notice-description, .ant-message-success .anticon,\n.ant-message-error .anticon {\n  font-size: 14px !important;\n  line-height: 16px !important;\n}\n\n.ant-notification-notice-error .ant-notification-notice-message,\n.ant-notification-notice-error .ant-notification-notice-description {\n  color: var(--flexi-error) !important;\n}\n\n.ant-notification-notice .ant-notification-notice-close {\n  color: var(--flexi-grey) !important;\n  top: 5px !important;\n  right: 12px !important;\n}\n\n.ant-notification-notice-icon {\n  font-size: 18px !important;\n  min-width: 18px !important;\n  width: 18px !important;\n  height: 18px !important;\n  line-height: 18px !important;\n}\n\n.ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 35px !important;\n}\n\n.ant-notification-notice-success .ant-notification-notice-message,\n.ant-notification-notice-success .ant-notification-notice-description, .ant-message-success  {\n  color: var(--flexi-valid) !important;\n}\n\n.ant-notification-notice {\n  display: inline-block !important;\n  width: auto !important;\n  max-width: 80vw !important;\n  white-space: nowrap !important;\n  min-width: 240px !important;\n}\n\n.ant-notification-notice-with-icon .ant-notification-notice-message, .ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-left: 35px !important;\n}\n\n.ant-notification-top {\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  right: auto !important;\n  top: 24px !important;\n}\n\n.ant-notification-fade-enter, .ant-notification-fade-appear {\n  animation-name: NotificationFadeInDown !important;\n}\n\n@keyframes NotificationFadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-40px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ant-cascader {\n  width: 80%\n}\n\n\n// ANT INPUT NUMBER\n.ant-input-number .ant-input-number-handler-wrap, .ant-input-number-focused .ant-input-number-handler-wrap {\n  opacity: 1;\n}\n\n.ant-input-number-affix-wrapper .ant-input-number-handler-wrap {\n  z-index: 0;\n}\n\n.ant-input-number-sm {\n  width: 75px;\n}\n\n.ant-input-number {\n  width: 70px;\n  border-radius: 2px !important;\n}\n\n.ant-input-prefix {\n  color: var(--flexi-placeholder) !important;\n}\n\n.ant-input {\n  border-radius: 2px !important;\n}\n// CHECKBOX\n.ant-table-filter-dropdown .ant-checkbox-checked, .ant-collapse .ant-checkbox-checked {\n  top: 0;\n\n  .ant-checkbox-inner {\n    position: absolute !important;\n    top: -2px;\n  }\n  \n  .ant-checkbox-input {\n    margin-right: 14px;\n  }\n}\n\n.ant-collapse .checkbox-all-outside .ant-checkbox {\n margin-left: 27px\n}\n\n.ant-tree-draggable-icon {\n  cursor: grab;\n\n    &:active {\n    cursor: grabbing;\n  }\n}\n\n// modal\n.ant-modal-content {\n  border-radius: 20px !important;\n  padding: 30px 10px !important;\n}\n\n.modal-preview-document .ant-modal-content {\n  padding: 0 !important;\n}\n\n.ant-btn-text span, .ant-modal-footer .ant-btn-default span, .ant-popover-buttons .ant-btn-default span {\n  text-decoration: underline !important;\n}\n\n.ant-modal-header {\n  border-bottom: none !important;\n  border-radius: 20px 20px 0 0 !important;\n}\n\n.ant-modal-footer {\n  padding: 0px 24px !important;\n  border-top: none !important;\n}\n\n.ant-modal-title {\n  font-size: 24px !important;\n  font-weight: 700 !important;\n  line-height: 30px !important;\n}\n\n.ant-modal-footer .ant-btn-default, .ant-popover .ant-btn-cancel  {\n  background: none !important;\n  border: none !important;\n  color: var(--flexi-primary-color, #2CB4AD) !important;\n  font-weight: 400 !important;\n  box-shadow: none !important;\n  cursor: pointer;\n}\n\n.ant-popover .ant-btn {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.ant-modal-body {\n    padding-top: 0;\n\n    > p {\n      font-size: 14px;\n      margin-bottom: 30px;\n    }\n\n    > b {\n      font-size: 13px;\n    }\n\n    > .ant-input-affix-wrapper {\n      border-radius: 25px !important;\n      font-weight: bold;\n      font-size: 13px;\n      margin: 7px 0;\n\n      svg {\n        color: var(--flexi-placeholder);\n      }\n    }\n\n  }\n  \n.modal-buttons {\n  margin-top: 30px;\n  display: flex;\n  justify-content: flex-end;\n\n  .ant-btn-text {\n    color: var(--flexi-primary-color);\n  }\n}\n\n.ant-popover-message > .anticon {\n  color: var(--flexi-warning) !important;\n}\n\n.ant-table-tbody .ant-table-cell .anticon {\n  transition: all .3s linear;\n  border-radius: 4px;\n\n  &:hover {\n    background-color: var(--flexi-col-table) !important;\n  }\n}\n\n.ant-tag-custom .ant-tag {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n// ANT TOOLTIP\n.flexi-rich-tooltip {\n  .ant-tooltip-inner {\n    border-radius: 6px;\n    padding: 8px 12px;\n    font-size: 12px;\n    line-height: 18px;\n    color: #fff;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    font-family: Roboto, sans-serif;\n    white-space: normal;\n    max-width: 450px;\n    min-width: 0;\n  }\n\n  .ant-tooltip-arrow {\n    display: none;\n  }\n\n  ul {\n    margin: 4px 0 0;\n    padding-left: 16px;\n    list-style: disc;\n\n    li {\n      margin: 0;\n      padding: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
